import React from 'react'
import styled from 'styled-components'
import Bookbank from '../image/Bookbank.svg'

// Styled-components
const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 90vh;
  padding: 20px;
  box-sizing: border-box;
`

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  &:hover {
    color: #888;
  }
`

const Logo = styled.img`
  width: 60%;
  margin-bottom: 20%;
  margin-top: 25%;
`

const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  color: #2425aa;
`

const Message = styled.p`
  margin: 15px 0 5px 0;
  font-size: 18px;
  text-align: center;
  color: #333;
`

const UserInfo = styled.div`
  margin: 5px 0 20px 0;
  text-align: center;
`

const RowInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
`

const TitleRow = styled.span`
  font-weight: bold;
  margin-right: 5px;
  font-size: 18px;
  color: #2425aa;
`

const UserTitle = styled.span`
  font-size: 18px;
  color: #2425aa;
  font-weight: bold;
`

const UserName = styled.p`
  margin: 0;
  font-size: 18px;
  color: #2425aa;
  font-weight: bold;
`

const BankNumber = styled.p`
  margin: 0;
  font-size: 18px;
  color: #2425aa;
  font-weight: bold;
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 5%;
`

const Button = styled.button`
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #2425aa;
  color: #fff;
  width: 100% !important;
  height: 45px;
  cursor: pointer;
  background-color: #2425aa;
  &:hover {
    background-color: #f2f2f2;
  }
`

const ButtonCancel = styled.button`
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #2425aa;
  color: #2425aa;
  width: 100% !important;
  height: 45px;
  cursor: pointer;
  &:hover {
    background-color: #2425aa;
    color: #fff;
  }
`

const ResultHandler = ({ props }) => {
  return (
    <Container>
      <CloseButton onClick={props.onClose}>&times;</CloseButton>
      <Logo src={Bookbank} alt="Logo" />
      <Title>{props.title}</Title>
      <Message>{props.message}</Message>
      {props.userinfo && (
        <UserInfo>
          <RowInfo>
            <TitleRow>ธนาคาร :</TitleRow>
            <UserTitle>{props.userinfo.bankname}</UserTitle>
          </RowInfo>
          <RowInfo>
            <TitleRow>ชื่อบัญชี :</TitleRow>
            <UserName>{props.userinfo.name}</UserName>
          </RowInfo>
          <RowInfo>
            <TitleRow>เลขบัญชี :</TitleRow>
            <BankNumber>{props.userinfo.banknumber}</BankNumber>
          </RowInfo>
        </UserInfo>
      )}
      <ButtonContainer>
        {props.onCancel && (
          <ButtonCancel
            color="primary"
            style={{
              width: window.innerWidth * 0.8,
            }}
            onClick={props.onCancel}
          >
            ยกเลิก
          </ButtonCancel>
        )}
        {props.onSubmit && (
          <Button
            color="primary"
            style={{
              width: window.innerWidth * 0.8,
            }}
            onClick={props.onSubmit}
          >
            ยืนยัน
          </Button>
        )}
      </ButtonContainer>
    </Container>
  )
}

export default ResultHandler
